/* eslint-disable react/jsx-newline */
import { useCallback, useState } from "react";

import DeleteAccountModal from "../components/DeleteAccountModal";
import DemographicsForm from "../components/DemographicsForm";
import ProfileInfoForm from "../../login/registration/ProfileInfoForm";
import SaveProfileModal from "../components/SaveProfileModal";
import TabHeader from "../components/TabHeader";
import { useAuth } from "../../../services/wp.auth.service";
import { useNotifications } from "../../../components/NotificationsContext";

const MyAccountProfile = () => {

	const { user } = useAuth();
	const { addNotification } = useNotifications();

	const [saveProfile, setSaveProfile] = useState(false);
	const closeSaveProfle = useCallback(() => setSaveProfile(false), []);

	const onSave = useCallback(() => {
		addNotification({
			message: "Profile saved successfully.",
			type: "success"
		});
	}, []);

	return (
		<>
			<TabHeader description="This is your profile." title="My Profile" />

			<ProfileInfoForm initialValues={user.attendeeDetails} onSuccess={onSave} />

			<hr className="my-5" />

			<h3>Demographics</h3>
			<DemographicsForm />

			<hr className="my-5" />

			<SaveProfileModal handleClose={closeSaveProfle} handleModalSubmit={closeSaveProfle} show={saveProfile} />

			<DeleteAccountModal />
		</>
	);
};

export default MyAccountProfile;
